import { principles, testimonials, stats } from '@/mocks/news';
import SubscribeForm from './SubscribeForm';

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8">
          <p className="flex items-center gap-2 text-sm font-bold tracking-widest text-primary-700">
            <span className="h-px w-8 bg-primary-500" /> 关于吃瓜新闻
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            把热点讲清楚，是我们对读者最大的诚意
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* 定位说明 */}
          <div className="flex flex-col gap-4">
            <p className="text-base leading-loose text-foreground-800">
              吃瓜新闻是一家以热点为入口的深度内容媒体。在信息纷繁、情绪先行的当下，我们选择“慢半拍”地坐下来：
              不急着下结论，而是把事件的来龙去脉、各方的说法与背后的行业逻辑，一层层还原给你看。
            </p>
            <p className="text-base leading-loose text-foreground-800">
              我们关注娱乐现场、社会议题与行业生态，用独家专访与深度报道，让热搜背后的真实故事被看见。这里只有负责任的复盘与有依据的追问，
              没有无证据的“起底”与对无关个人的伤害。
            </p>
            <div className="grid grid-cols-2 gap-3">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg border border-background-200 bg-background-100/60 px-4 py-4"
                >
                  <p className="font-heading text-2xl font-black text-primary-700">{s.value}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 编辑原则 */}
          <div className="rounded-lg border border-background-200 bg-background-100/60 p-6">
            <h3 className="font-heading text-lg font-bold text-foreground-950">我们的内容原则</h3>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="flex gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${p.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-950">{p.title}</h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-700">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 口碑 */}
        <div className="mt-12">
          <div className="mb-5 flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-chat-3-line text-accent-600" aria-hidden="true" /> 读者怎么说
            </h3>
            <span className="text-xs text-foreground-600">来自评论区 · 私信与后台留言</span>
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="flex gap-0.5 text-accent-500">
                  <i className="ri-star-fill text-sm" aria-hidden="true" />
                  <i className="ri-star-fill text-sm" aria-hidden="true" />
                  <i className="ri-star-fill text-sm" aria-hidden="true" />
                  <i className="ri-star-fill text-sm" aria-hidden="true" />
                  <i className="ri-star-fill text-sm" aria-hidden="true" />
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-800">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-3 text-xs text-foreground-600">
                  —— {t.name}（{t.role}）
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>

      {/* 订阅 CTA 带 */}
      <div className="border-y border-background-200 bg-accent-100/70">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
          <div className="grid grid-cols-1 items-center gap-6 lg:grid-cols-2">
            <div>
              <p className="text-sm font-bold tracking-widest text-accent-700">免费订阅 · 每周 3 期</p>
              <h3 className="mt-2 font-heading text-xl font-black text-foreground-950 md:text-2xl">
                让深度内容，主动来到你身边
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                留下邮箱，订阅我们的深度报道精选与独家专访，不错过任何一个值得细看的话题。随时可以退订。
              </p>
            </div>
            <div>
              <SubscribeForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}